<template>
  <div :class="{ 'max-width-650': $vuetify.breakpoint.mdAndUp }">
    <v-card class="pa-2" v-if="hoursOnDay.length > 0 && !isAddNew">
      <v-layout wrap>
        <span>{{ $t('message.common.date') }} : {{ formatDate(hoursOnDay[0].date) }}</span>
        <v-card-text class="pa-0">
          <v-divider></v-divider>
          <v-simple-table class="bordered--table mt-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="25%">{{ $t('message.common.employee') }}</th>
                  <th width="25%">{{ $t('message.stamp.activity') }}</th>
                  <th width="20%">{{ $t('message.common.date') }}</th>
                  <th width="10%">{{ $t('message.timer.hours') }}</th>
                  <th width="20%">{{ $t('message.common.state') }}</th>
                  <th width="15%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="hour in hoursOnDay" :key="hour.id" :class="hour.isSoTask ? 'so_task_row' : ''">
                  <td>{{ getEmployeeName(hour.projectmemberid) }}</td>
                  <td>{{ hour.activityid ? activities.find(x=>x.id === hour.activityid) ? activities.find(x=>x.id === hour.activityid).name : '' : '' }}</td>
                  <td>{{ formatDate(hour.date) }}</td>
                  <td>{{ hour.hours | replaceDotWithComma}}</td>
                  <td>{{ getStatusText(hour.state) }}</td>
                  <td nowrap v-if="hour.state !== 'approved'"><!-- hour.projectmemberid === activeUser.id && -->
                    <v-btn color="primary" v-if="!isHourEditable(hour.state)" text small fab @click="editSingleLog(hour.id, hour.isSoTask, hour.projectmemberid !== activeUser.id)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" v-if="!hour.isSoTask ? !isHourEditable(hour.state) : false" text small fab @click="deleteHourHandler(hour.id)">
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                    <v-btn color="info" v-if="isHourEditable(hour.state)" text small fab @click="previewHourHandler(hour.id)">
                      <v-icon>visibility</v-icon>
                    </v-btn>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                      <v-btn v-on="on" v-if="isUserHasAccess(hour) && hour.state ==='not_delivered'" color="success" text small fab @click="deliverHourEntry(hour)">
                        <v-icon>mdi-alarm-check</v-icon><!-- mdi-check-circle -->
                      </v-btn>
                      </template>
                      <span>{{ $t('message.timer.deliver') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-layout>
      <v-divider class="mt-1"></v-divider>
      <v-card-actions class="pa-0 mt-2">
        <v-btn color="success" @click="addNewLog">{{ $t('message.common.addNew') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeLogForm">{{ $t('message.common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
    <form-data v-else :references.sync="formReferences" :model="hourObj" ref="hourReference"></form-data>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FormTemplate from '../../../components/FormTemplate'
import CONSTANTS from '@/assets/json/constants.json'
import _localStorage from '@/plugins/local_storage'
export default {
  props: ['hourObj', 'hoursOnDay', 'worktypes', 'users', 'activities', 'currentProjects'],
  data () {
    return {
      MODULE: 'hourloggings',
      isAddNew: false,
      isReadOnly: false,
      logObj: {},
      listOfActivities: [],
      activeUser: {},
      isShowUserField: false
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapGetters(['formType']),
    formReferences () {
      var formReferences = {
        title: this.hourObj.id ? this.$t('message.timer.editHours') : this.$t('message.timer.addHours'),
        properties: [{
          model: 'projectid',
          type: this.formType.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.currentProjects,
          select_text: (val) => `${val.name}`,
          select_value: 'id',
          disabled: this.isReadOnly,
          label: this.$t('message.layout.projects'),
          class: 'xs12'
        }, {
          model: 'projectmemberid',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.users,
          is_list: false,
          click: (search) => false,
          term: '',
          disabled: true,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.user'),
          class: 'xs12'
        }, /* {
          model: 'worktypeid',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.worktypes,
          is_list: false,
          click: (search) => false,
          term: '',
          disabled: this.isReadOnly,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.worktypes'),
          class: 'xs12'
        }, */ /* {
          model: 'task',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.common.task'),
          class: 'xs12'
        },  */{
          model: 'date',
          type: this.formType.DATEPICKER,
          rules: this.$_requiredValidation,
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: '',
          disabled: this.isReadOnly,
          class: 'sm6 xs12'
        }, {
          model: 'hours',
          type: this.formType.TEXT,
          rules: this.$_HourValidation,
          label: this.$t('message.timer.hours'),
          class: 'sm6 xs12'
        }, {
          model: 'activityid',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.listOfActivities,
          is_list: false,
          click: (search) => false,
          term: '',
          disabled: this.isReadOnly,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.activities'),
          class: 'xs12'
        }, {
          model: 'finder',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.users,
          is_list: false,
          click: (search) => false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.timer.finder'),
          class: 'sm6 xs12'
        }, {
          model: 'findersfee',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.timer.findersFee'),
          class: 'sm6 xs12'
        }, {
          model: 'comments',
          type: this.formType.TEXTAREA,
          rules: this.$_requiredValidation,
          disabled: this.isReadOnly,
          label: this.$t('message.common.comments'),
          class: 'xs12'
        }, {
          model: 'not_approved_comment',
          type: this.formType.TEXTAREA,
          rules: [],
          is_show: this.hourObj.state === CONSTANTS.NOT_APPROVED,
          disabled: true,
          label: this.$t('message.timer.notApproved'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.hourObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          disabled: this.isReadOnly,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: this.closeLogForm,
          label: this.$t('message.common.close'),
          to: '/user',
          is_show: true
        }]
      }
      if (!this.isShowUserField) formReferences.properties.splice(1, 1)
      return formReferences
    }
  },
  mounted () {
    // worktype default set
    /* let worktype = this.worktypes.find(x => x.isdefault)
    if (worktype) this.hourObj.worktypeid = worktype.id */
    // activities default set
    this.listOfActivities = this.activities.filter(x => x.project_id === this.hourObj.projectid)
    let activity = this.listOfActivities.find(x => x.isdefault)
    if (activity) this.hourObj.activityid = activity.id
    // read active user
    let getActiveuser = _localStorage.get(process.env.VUE_APP_USER) // this.$cookie.get(process.env.VUE_APP_USER)
    this.activeUser = getActiveuser ? JSON.parse(getActiveuser) : {}
    if (this.activeUser.id) this.activeUser.id = parseInt(this.activeUser.id)
    // check is so task and single entry then open the modal form
    if (this.hoursOnDay && this.hoursOnDay.length === 1 && this.hoursOnDay[0].isSoTask) {
      let soTask = this.hoursOnDay[0]
      this.isAddNew = true
      this.$eventBus.$emit('editSingleEntry', soTask.id, soTask.isSoTask)
    }
  },
  watch: {
    'hourObj.datePicker' (val) {
      if (val) {
        this.hourObj.date = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'hourObj.projectid' (val) {
      if (val) this.listOfActivities = this.activities.filter(x => x.project_id === val)
    }
  },
  methods: {
    deleteHourHandler (id) {
      let ids = [id]
      let payload = { ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
      this.$store.commit('showDeleteDialog', payload)
    },
    addNewLog () {
      this.isAddNew = true
      this.$eventBus.$emit('addNewEntry')
    },
    editSingleLog (id, isSoTask, isNotActiveUser) {
      if (isNotActiveUser) this.isShowUserField = true
      this.isAddNew = true
      // let obj = this.worktypes.find(x => x.isdefault)
      this.$eventBus.$emit('editSingleEntry', id, isSoTask) // obj ? obj.id : ''
    },
    previewHourHandler (id) {
      this.isAddNew = this.isReadOnly = true
      this.$eventBus.$emit('editSingleEntry', id)
    },
    saveUpdateHandler () {
      if (this.$refs.hourReference.$refs.validateForm.validate()) {
        this.loading = true
        let transformData = { date: { list: ['date'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        let model = this.$format.formatModel(this.hourObj, transformData)
        let transformNumber = { number: { list: ['hours', 'findersfee'], format: 'replaceCommaWithDot' } }
        model = this.$format.formatModel(model, transformNumber)
        model.state = model.id ? model.state !== CONSTANTS.NOT_APPROVED ? model.state : CONSTANTS.NOT_DELIVERED : CONSTANTS.NOT_DELIVERED
        model.projectmemberid = model.id ? model.projectmemberid : this.activeUser.id
        model.type = CONSTANTS.WORKING
        let url = this.MODULE
        this.$api.saveUpdateHandler(url, model)
          .then((response) => {
            if (model.isSoTask) {
              this.$api.execute('post', `sotasks/mark_as_entered?id=${model.soTaskId}`)
                .then((markedResponse) => {
                })
            }
            this.closeLogForm()
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.$eventBus.$emit('getAllHourLogs')
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    isHourEditable (state) {
      if (!state) return false
      if (state === this.APPROVED || state === this.DELIVERED) return true
      else return false
    },
    getStatusText (status) {
      if (!status) return ''
      switch (status) {
        case 'approved':
          return this.$t('message.timer.approved')
        case 'not_approved':
          return this.$t('message.timer.notApprovedMsg')
        case 'delivered':
          return this.$t('message.timer.delivered')
        case 'not_delivered':
          return this.$t('message.timer.notDelivered')
        default:
          break
      }
    },
    getEmployeeName (employeeId) {
      let obj = this.users.find(x => x.id === employeeId)
      return obj ? obj.name : ''
    },
    closeLogForm () {
      this.$eventBus.$emit('closeForm')
      if (this.$refs && this.$refs.hourReference) this.$refs.hourReference.$refs.validateForm.reset()
    },
    formatTime (date) {
      return this.$format.formatDate(date, 'DD.MM.YYYY HH:mm', 'HH:mm')
    },
    formatDate (date) {
      return this.$format.formatDate(date, 'YYYY.MM.DD', 'DD.MM.YYYY')
    },
    isUserHasAccess (hourObj) {
      if (this.activeUser.isadmin) return true
      let hasAccess = false
      const thisProject = this.currentProjects.find(x => x.id === hourObj.projectid) || {}
      if (thisProject) hasAccess = parseInt(this.activeUser.so_user_id) === parseInt(thisProject.responsibleid)
      return hasAccess
    },
    approveHourEntry (hour) {
      this.$api.getSingleRecordHandler(`${this.MODULE}/${hour.id}`)
        .then((result) => {
          let hour = result.data
          hour.state = CONSTANTS.APPROVED
          this.$api.saveUpdateHandler(this.MODULE, hour)
            .then((response) => {
              this.closeLogForm()
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
              this.$eventBus.$emit('getAllHourLogs')
            })
        })
    },
    deliverHourEntry (hour) {
      let model = { ids: [hour.id], parameters: { state: CONSTANTS.DELIVERED } }
      this.$api.execute('put', `${this.MODULE}/bulk_update`, model)
        .then((response) => {
          this.closeLogForm()
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.timer.deliveredSuccessfully') })
          this.$eventBus.$emit('getAllHourLogs')
        })
    }
  }
}
</script>
<style>
.max-width-500 {
  max-width: 500px
}
.max-width-600 {
  max-width: 600px
}
.max-width-650 {
  max-width: 650px
}
.bordered--table {
  width: 100%;
}
.bordered--table table, .bordered--table table thead tr, .bordered--table table tbody tr {
  border: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead th, .bordered--table table tbody tr td {
  border-right: 1px solid rgba(0,0,0,0.12);
}
.so_task_row {
  background: #0095ff;
  color: white;
}
.so_task_row:hover {
  background:#0095ffbd !important;
  color: white;
}
</style>
